import { z } from "zod/v4";
import { leagueMatchSetSchema } from "./matches";

export const leagueMatchRevisionKindSchema = z.enum(["entered", "edited", "upheld", "voided"]);

export const leagueMatchRevisionBySchema = z.object({
	display_name: z.string(),
	user_id: z.string().uuid(),
});

// What the result looked like right before this revision — null for "entered"
// (there is no "before" the first write).
export const leagueMatchRevisionBeforeSchema = z.object({
	played_on: z.string(),
	sets: z.array(leagueMatchSetSchema),
	status: z.enum(["pending", "disputed", "confirmed"]),
	winner_side: z.union([z.literal(1), z.literal(2)]),
});

export const leagueMatchRevisionSchema = z.object({
	at: z.coerce.date(),
	before: leagueMatchRevisionBeforeSchema.nullable(),
	by: leagueMatchRevisionBySchema.nullable(),
	kind: leagueMatchRevisionKindSchema,
	note: z.string().nullable(),
	revision: z.number().int(),
});

// Oldest first — staff only.
export const leagueMatchRevisionListResponseSchema = z.object({
	items: z.array(leagueMatchRevisionSchema),
});
